import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import PropTypes from "prop-types";
import axios from "axios";

import ScreamSkeleton from "../util/ScreamSkeleton";

import { connect } from "react-redux";
import { getScreams } from "../redux/actions/dataActions";
import Board from "../components/ArchivedChess/Board";
import { Chess } from "chess.js";
import Controls from "../components/ArchivedChess/Controls";
import Moves from "../components/ArchivedChess/Moves";
import { fetchGame, fetchNextGame, putGame } from "../util/api/game";
import { getMove, updateCommentIdInMoves } from "../util/Chess";
import AddComment from "../components/ArchivedChess/AddComment";
import Select from "react-select";
import { ChessSocialContext } from "../util/ChessSocialContext";
import GameSummary from "./GameSummary";
import chessslogo from "../images/chessslogo.png";
import iPhone from "../images/iPhone.png";
import mansalva from '../images/Mansalva/Mansalva-Regular.ttf';
import MOCK_GAMES from '../Administration/mockGames';
import { 
  getFeaturedGameData, 
  getGameOfDayHistory, 
  getGameOfDayHistoryWithDates, 
  getFeaturedCreators, 
  removeGameFromHistory,
  getTipOfDay,
  getQuoteOfDay,
  getFactOfDay,
  getAllDailyContent
} from '../util/api/featuredContent';
import { TAGS } from '../util/constants';
import { usePremium } from '../util/PremiumFilter';
import { doc, getDoc, collection, query, where, getDocs, updateDoc, writeBatch, addDoc } from 'firebase/firestore';
import { db } from '../util/firebase';

import Shop from "../images/Shop.png";

import chesslogo from "../images/chessslogo.png";

// Separate arrays for tips, quotes, and facts as fallbacks
const chessTips = [
  "Develop knights before bishops in most openings. Bishops are more flexible, based on the position.",
  
];

const chessQuotes = [
  "Chess is life in miniature. Chess is struggle. Chess is battles. - Garry Kasparov",

];

const chessFacts = [
  "The longest possible chess game is 5,949 moves, due to the 50 move rule.",
];

// Update YouTube videos array with more robust parameters
const YOUTUBE_VIDEOS = [
  "https://www.youtube.com/embed/5bcT__RV384?autoplay=1&controls=0&showinfo=0&rel=0&enablejsapi=1&origin=http://localhost:3000&mute=1&playlist=5bcT__RV384",
  "https://www.youtube.com/embed/0nY54s1Mk6s?autoplay=1&controls=0&showinfo=0&rel=0&enablejsapi=1&origin=http://localhost:3000&mute=1&playlist=0nY54s1Mk6s",
  "https://www.youtube.com/embed/K3rInl31-94?autoplay=1&controls=0&showinfo=0&rel=0&enablejsapi=1&origin=http://localhost:3000&mute=1&playlist=K3rInl31-94"
];

// Add a style block to define the font-face
const MansalvaFontStyle = () => {
  return (
    <style>
      {`
        @font-face {
          font-family: 'Mansalva';
          src: url(${mansalva}) format('truetype');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
        }
      `}
    </style>
  );
};

const Explore = (props) => {
  const { renderUserWithBadge, isPremiumUser } = usePremium();
  const { setActiveTab, activeTab } = useContext(ChessSocialContext);
  const [isLoading, setIsLoading] = useState(false);
  const [activeView, setActiveView] = useState('trending');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentGameIndex, setCurrentGameIndex] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  
  // Updated state for Game of the Day to include date
  const [featuredGameId, setFeaturedGameId] = useState(null);
  const [featuredGameDate, setFeaturedGameDate] = useState(null);
  const [gameHistory, setGameHistory] = useState([]);
  const [gameHistoryDates, setGameHistoryDates] = useState([]);
  const [currentHistoryIndex, setCurrentHistoryIndex] = useState(0);
  const [isLoadingGameOfDay, setIsLoadingGameOfDay] = useState(true);
  const [error, setError] = useState(null);
  
  // New state for Featured Creators
  const [featuredCreators, setFeaturedCreators] = useState([]);
  const [isLoadingCreators, setIsLoadingCreators] = useState(false);

  const [gameOfDayList, setGameOfDayList] = useState([]);
  const [gameOfDay, setGameOfDay] = useState(null);
  const [gameOfDayIndex, setGameOfDayIndex] = useState(0);
  const [loadedGameData, setLoadedGameData] = useState([]); // Store actual game data

  // Add a new state to track the content type 
  const [contentType, setContentType] = useState('tip');
  
  // Add new states for dynamic content from Firebase
  const [dynamicTip, setDynamicTip] = useState('');
  const [dynamicQuote, setDynamicQuote] = useState('');
  const [dynamicFact, setDynamicFact] = useState('');
  const [isLoadingDailyContent, setIsLoadingDailyContent] = useState(true);

  // Add new state variables for follow functionality
  const [followLoading, setFollowLoading] = useState({}); // Track loading state per creator
  const authenticatedUserHandle = props?.user?.credentials?.handle; // Current logged-in user's handle
  const authenticatedUserId = props?.user?.credentials?.userId; // Current logged-in user's ID

  // Add a new state for creator premium data
  const [creatorPremiumData, setCreatorPremiumData] = useState({});

  // Update the useEffect to cycle between content types every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      // First update the content type in rotation: tip -> quote -> fact -> tip
      setContentType(prevType => {
        if (prevType === 'tip') return 'quote';
        if (prevType === 'quote') return 'fact';
        return 'tip'; // Return to tip from fact
      });
      
      // We don't need to increment the index anymore since we're using dynamic content
      // But keep this in case we need to fall back to the arrays
      setCurrentIndex(prev => (prev + 1) % Math.max(chessTips.length, chessQuotes.length, chessFacts.length));
    }, 5000);
    
    return () => clearInterval(interval);
  }, []);

  // Add a new useEffect to fetch the dynamic content from Firebase
  useEffect(() => {
    const fetchDailyContent = async () => {
      setIsLoadingDailyContent(true);
      try {
        // Use the getAllDailyContent function to get all daily content at once
        const dailyContent = await getAllDailyContent();
        
        // Set the dynamic content values or fall back to the static arrays
        setDynamicTip(dailyContent.tip || chessTips[0]);
        setDynamicQuote(dailyContent.quote || chessQuotes[0]);
        setDynamicFact(dailyContent.fact || chessFacts[0]);
        
        setIsLoadingDailyContent(false);
      } catch (err) {
        // console.error('Error fetching daily content:', err);
        // Fall back to static content if there's an error
        setDynamicTip(chessTips[0]);
        setDynamicQuote(chessQuotes[0]);
        setDynamicFact(chessFacts[0]);
        setIsLoadingDailyContent(false);
      }
    };
    
    fetchDailyContent();
  }, []);

  // Update useEffect to fetch game of the day with history dates
  useEffect(() => {
    const fetchGameOfDayData = async () => {
      setIsLoadingGameOfDay(true);
      try {
        // First fetch the current featured game data
        const currentGameData = await getFeaturedGameData();
        
        // Then fetch the history with dates
        const historyWithDates = await getGameOfDayHistoryWithDates();
        const historyData = historyWithDates.history || [];
        const historyDates = historyWithDates.historyDates || {};
        
        // Store dates for display
        setGameHistoryDates(historyDates);
        
        // Combine current game with history if available
        let gameIds = [];
        
        if (currentGameData.gameId) {
          // Add current game ID as the first item if it exists
          gameIds.push(currentGameData.gameId);
          // Store date of current game
          setFeaturedGameDate(currentGameData.date || new Date().toISOString().split('T')[0]);
        }
        
        // Add historical games (excluding the current one to avoid duplicates)
        if (historyData && historyData.length > 0) {
          // Add unique history games (excluding current game)
          historyData.forEach(id => {
            if (id !== currentGameData.gameId && !gameIds.includes(id)) {
              gameIds.push(id);
            }
          });
        }
        
        // Set the full list
        setGameOfDayList(gameIds);
        
        if (gameIds && gameIds.length > 0) {
          // Fetch the actual game data for all IDs at once
          const gameDataPromises = gameIds.map(async (gameId) => {
            try {
              // Use the existing fetchGame function
              const gameData = await fetchGame(gameId);
              return { 
                id: gameId,
                ...gameData,
                // Add any missing properties that GameSummary might expect
                _fetchComplete: true  // Flag to indicate this data is complete
              };
            } catch (err) {
              // console.error(`Error fetching game ${gameId}:`, err);
              return null;
            }
          });
          
          // Wait for all game data to be fetched
          const gamesData = await Promise.all(gameDataPromises);
          
          // Filter out any null results (failed fetches)
          const validGameData = gamesData.filter(game => game !== null);
          
          if (validGameData.length > 0) {
            setLoadedGameData(validGameData);
            setGameOfDay(validGameData[0]); // Set the first game as current
            setGameOfDayIndex(0);
          }
        }
        
        setIsLoadingGameOfDay(false);
      } catch (error) {
        // console.error('Error fetching Game of the Day:', error);
        setIsLoadingGameOfDay(false);
      }
    };
    
    fetchGameOfDayData();
  }, []);
  
  // Fetch featured creators
  useEffect(() => {
    const fetchCreatorsData = async () => {
      try {
        setIsLoadingCreators(true);
        const creators = await getFeaturedCreators();
        
        if (creators && creators.length > 0) {
          // Check follow status for each creator
          const creatorsWithFollowStatus = await updateCreatorsFollowStatus(creators);
          setFeaturedCreators(creatorsWithFollowStatus);
          
          // Fetch premium data for creators
          await fetchCreatorPremiumData(creatorsWithFollowStatus);
        }
        
        setIsLoadingCreators(false);
      } catch (err) {
        // console.error("Error fetching featured creators:", err);
        // Fall back to default creators, no need to show error
        setIsLoadingCreators(false);
      }
    };
    
    fetchCreatorsData();
  }, [authenticatedUserHandle]);

  // Function to fetch premium data for creators
  const fetchCreatorPremiumData = async (creatorsData) => {
    if (!creatorsData || creatorsData.length === 0) return;
    
    try {
      // Get usernames needing premium data fetched
      const creatorUsernames = creatorsData.map(creator => {
        // Remove @ symbol if present
        return creator.username.replace(/^@/, '');
      });
      
      // Only fetch for usernames we don't already have data for
      const usernamesToFetch = creatorUsernames.filter(
        username => !creatorPremiumData[username]
      );
      
      if (usernamesToFetch.length === 0) return;
      
      // Fetch premium data for each username
      const promises = usernamesToFetch.map(username => 
        axios.get(`/user/${username}`)
          .then(response => {
            if (response.data && response.data.user) {
              return { username, premium: response.data.user.premium };
            }
            return { username, premium: 0 };
          })
          .catch(() => ({ username, premium: 0 }))
      );
      
      const results = await Promise.all(promises);
      
      // Update premium data state
      setCreatorPremiumData(prev => {
        const updatedData = { ...prev };
        results.forEach(result => {
          updatedData[result.username] = result.premium;
        });
        return updatedData;
      });
    } catch (error) {
      // console.error('Error fetching creator premium data:', error);
    }
  };

  // Function to check if we need to load more games
  const checkAndLoadMoreGames = () => {
    // If we have 2 or fewer games left in our loaded data, fetch more
    if (loadedGameData.length > 0 && gameOfDayIndex >= loadedGameData.length - 2) {
      // Calculate how many more games we need (aim to have 5 total)
      const additionalNeeded = 5 - (loadedGameData.length - gameOfDayIndex);
      
      if (additionalNeeded > 0 && gameOfDayList.length > loadedGameData.length) {
        // There are more games in the list that we haven't loaded yet
        const nextBatchIndices = [];
        
        // Start from the end of our currently loaded games
        const startIndex = loadedGameData.length;
        
        // Get the next batch of game IDs
        for (let i = 0; i < additionalNeeded && startIndex + i < gameOfDayList.length; i++) {
          nextBatchIndices.push(gameOfDayList[startIndex + i]);
        }
        
        if (nextBatchIndices.length > 0) {
          // Load these games in the background
          (async () => {
            try {
              const gameDataPromises = nextBatchIndices.map(async (gameId) => {
                try {
                  const gameData = await fetchGame(gameId);
                  return { 
                    id: gameId, 
                    ...gameData,
                    _fetchComplete: true  // Same flag for additionally loaded games
                  };
                } catch (err) {
                  // console.error(`Error fetching additional game ${gameId}:`, err);
                  return null;
                }
              });
              
              const additionalGamesData = await Promise.all(gameDataPromises);
              const validAdditionalData = additionalGamesData.filter(game => game !== null);
              
              if (validAdditionalData.length > 0) {
                // Add these to our existing loaded games
                setLoadedGameData(prevData => [...prevData, ...validAdditionalData]);
              }
            } catch (error) {
              // console.error('Error fetching additional games:', error);
            }
          })();
        }
      }
    }
  };

  // Modified prevGame function to cycle through previous games
  const prevGame = () => {
    if (loadedGameData.length > 0) {
      const newIndex = (gameOfDayIndex + 1) % loadedGameData.length; // Note: This moves forward in the array
      setGameOfDayIndex(newIndex);
      // Use spread operator to ensure state update is recognized
      setGameOfDay({...loadedGameData[newIndex]});
      
      // Check if we need to load more games
      checkAndLoadMoreGames();
    }
  };

  // Updated nextGame function to only allow going back to today's game
  const nextGame = () => {
    if (loadedGameData.length > 0 && gameOfDayIndex !== 0) {
      // Only allow going back to today's game, not to future games
      setGameOfDayIndex(0);
      setGameOfDay({...loadedGameData[0]});
    } else {
      // If already at today's game and trying to go next, show popup
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
      }, 2000);
    }
  };

  // Update the showTomorrowPopup function
  const showTomorrowPopup = () => {
    // If not at today's game, return to it
    if (gameOfDayIndex !== 0) {
      nextGame();
    } else {
      // Otherwise show the popup (can't go to tomorrow)
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
      }, 2000);
    }
  };

  // Get the current game ID to display
  const getCurrentGameId = () => {
    if (gameHistory.length > 0) {
      return gameHistory[currentHistoryIndex];
    }
    return null;
  };

  // Functions to cycle through videos
  const nextVideo = useCallback(() => {
    setCurrentVideoIndex((prevIndex) =>
      prevIndex === YOUTUBE_VIDEOS.length - 1 ? 0 : prevIndex + 1
    );
  }, []);

  const prevVideo = useCallback(() => {
    setCurrentVideoIndex((prevIndex) =>
      prevIndex === 0 ? YOUTUBE_VIDEOS.length - 1 : prevIndex - 1
    );
  }, []);

  // Load YouTube API
  useEffect(() => {
    // Load YouTube IFrame API
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    // Setup YouTube API ready callback
    window.onYouTubeIframeAPIReady = initializeYouTubePlayer;

    // If API is already loaded, initialize player directly
    if (window.YT && window.YT.Player) {
      initializeYouTubePlayer();
    }

    return () => {
      // Clean up
      window.onYouTubeIframeAPIReady = null;
    };
  }, [currentVideoIndex]);

  // Initialize YouTube player
  const initializeYouTubePlayer = useCallback(() => {
    if (!window.YT || !window.YT.Player) return;
    
    // Extract video ID from the URL
    const videoUrl = YOUTUBE_VIDEOS[currentVideoIndex];
    const videoId = videoUrl.split('embed/')[1].split('?')[0];
    
    // Create container for player if it doesn't exist
    const playerContainer = document.getElementById('youtube-player-container');
    if (!playerContainer) return;
    
    // Clear container
    playerContainer.innerHTML = '';
    
    // Create a wrapper div for centering
    const wrapperDiv = document.createElement('div');
    wrapperDiv.style.width = '100%';
    wrapperDiv.style.height = '100%';
    wrapperDiv.style.display = 'flex';
    wrapperDiv.style.justifyContent = 'center';
    wrapperDiv.style.alignItems = 'center';
    playerContainer.appendChild(wrapperDiv);
    
    // Create a div for the player at 98% size
    const playerDiv = document.createElement('div');
    playerDiv.id = 'youtube-player';
    playerDiv.style.width = '98%';
    playerDiv.style.height = '98%';
    wrapperDiv.appendChild(playerDiv);
    
    // Create new player
    if (playerRef.current) {
      playerRef.current.destroy();
    }
    
    playerRef.current = new window.YT.Player('youtube-player', {
      videoId: videoId,
      height: '100%',
      width: '100%',
      playerVars: {
        autoplay: 1,
        controls: 0,
        showinfo: 0,
        rel: 0,
        enablejsapi: 1,
        modestbranding: 1,
        mute: 1, // Start muted to allow autoplay
        loop: 0,
        playsinline: 1
      },
      events: {
        onReady: onPlayerReady,
        onStateChange: onPlayerStateChange,
        onError: onPlayerError
      }
    });
  }, [currentVideoIndex]);

  // Player event handlers
  const onPlayerReady = useCallback((event) => {
    // Unmute after player is ready (if needed)
    event.target.playVideo();
    
  }, []);

  const onPlayerStateChange = useCallback((event) => {
    // When video ends (state = 0), play next video
    if (event.data === window.YT.PlayerState.ENDED) {
      
      nextVideo();
    }
  }, [nextVideo]);

  const onPlayerError = useCallback((event) => {
    // console.error('YouTube player error:', event.data);
    // If there's an error, try playing the next video
    nextVideo();
  }, [nextVideo]);

  const styles = {
    upgradeButton: {
      background: '#ff0050',
      color: 'gold',
      border: 'none',
      borderRadius: '5px',
      marginTop: '10px',
      height: '60px',
      fontWeight: 'bold',
      fontSize: '18px',
      border: '3px solid gold',
    },
    h1: {
      margin: 0,
      fontSize: '24px',
      color: '#fff',
    },
    section: {
      margin: '8px 0',
      padding: '10px',
      background: '#111',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
    },
    h2: {
      fontSize: '18px',
      margin: '0 0 8px 0',
      color: 'white',
      textAlign: 'center',
    },
    matchScroll: {
      display: 'flex',
      overflowX: 'auto',
      gap: '8px',
      padding: '4px 0',
      marginBottom: '8px',
    },
    matchItem: {
      background: '#1a1a1a',
      padding: '6px 12px',
      borderRadius: '16px',
      whiteSpace: 'nowrap',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
    },
    creatorCard: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      paddingLeft: '10px',
      background: '#1a1a1a',
      borderRadius: '8px',
      color: 'white',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
    },
    creatorAvatar: {
      width: '36px',
      height: '36px',
      borderRadius: '50%',
    },
    creatorInfo: {
      flex: 1,
    },
    creatorActions: {
      display: 'flex',
      gap: '6px',
    },
    button: {
      padding: '6px 12px',
      borderRadius: '16px',
      background: '#1a1a1a',
      color: '#fff',
      cursor: 'pointer',
      transition: 'all 0.2s',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
    },
    premiumButton: {
      background: '#ffd700',
      color: '#000',
      border: 'none',
    },
    tweetCard: {
      padding: '8px',
      background: '#1a1a1a',
      borderRadius: '8px',
      marginBottom: '8px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
    },
    tweetHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
    },
    tweetMeta: {
      color: '#aaa',
      fontSize: '12px',
    },
    statsQuote: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '8px',
    },
    statBox: {
      background: '#1a1a1a',
      padding: '8px',
      borderRadius: '6px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
    },
    premiumTeaser: {
      position: 'relative',
      aspectRatio: '9/16',
      background: '#000',
      borderRadius: '8px',
      overflow: 'hidden',
    },
    premiumOverlay: {
      position: 'absolute',
      inset: 0,
      background: 'rgba(0,0,0,0.7)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
    },
    twoColumnLayout: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '16px',
      width: '100%',
    },
    threeColumnLayout: {
      display: 'flex',
      gap: '16px',
      width: '100%',
      height: 'calc(100vh - 120px)', // Adjust based on header height
    },
    column: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    infoBox: {
      backgroundColor: '#2a2a2a',
      padding: '12px',
      borderRadius: '8px',
      marginTop: '8px',
      color: 'white',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
    },
    verticalVideo: {
      backgroundColor: '#1a1a1a',
      borderRadius: '8px',
      marginBottom: '16px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
    },
    bottomSection: {
      marginTop: 'auto',
    },
  };

  // Add initial game data
  const initialGameData = {
    position: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1', // Starting position
    moves: [],
    comments: [],
    result: '*',
    white: 'Player 1',
    black: 'Player 2',
    date: new Date().toISOString()
  };

  // Add this useEffect to load Twitter widgets
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://platform.twitter.com/widgets.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % chessTips.length);
    }, 5000); // Change every 24 hours 86400000
    return () => clearInterval(interval);
  }, []);

  // Helper function to format a date for display
  const formatDate = (dateString) => {
    if (!dateString) return null;
    
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric', 
      });
    } catch (e) {
      // console.error("Error formatting date:", e);
      return dateString;
    }
  };
  
  // Function to get the title of the currently displayed game
  // Returns an object with main title and date parts for different styling
  const getGameOfDayTitle = () => {
    if (gameOfDayIndex === 0) {
      return { main: "Game Of The Day", date: null };
    } else if (gameOfDayIndex === 1) {
      return { main: "Game Of The Day", date: "yesterday" };
    } else {
      // Get the date for the current game if available
      const currentGameId = loadedGameData[gameOfDayIndex]?.id;
      let dateString = null;
      
      if (currentGameId && gameHistoryDates[currentGameId]) {
        dateString = formatDate(gameHistoryDates[currentGameId]);
      }
      
      if (dateString) {
        return { main: "Game Of The Day", date: dateString };
      } else {
        return { main: "Previous Game Of The Day", date: `#${gameOfDayIndex}` };
      }
    }
  };

  // Update the renderGameOfDay function to include a remove button
  const renderGameOfDay = () => {
    return (
      <div className="game-of-day-container" style={{
        backgroundColor: '#111',
        borderRadius: '10px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flex: '0 70%', // Fixed height ratio (80%)
        overflow: 'hidden'
      }}>
        <div style={{}}>
        <h2 style={{
          color: 'white',
          textAlign: 'center',
          fontSize: '24px'
        }}>{getGameOfDayTitle().main}</h2>

        {/* Display the date part if it exists */}
        {getGameOfDayTitle().date && (
          <div style={{
            color: '#999', // Gray color
            fontSize: '14px', // Smaller font
            marginTop: '-22px', // Negative margin to bring it closer to the main title
            textAlign: 'center'
          }}>
            {getGameOfDayTitle().date}
          </div>
        )}
        </div>
        <div className="game-of-day-content" style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
          width: '100%',
          position: 'relative',
          height: 'calc(100% - 40px)' // Subtract header height
        }}>
          <button
            onClick={prevGame} // This now goes to PREVIOUS days
            style={{
              background: 'transparent',
              border: 'none',
              color: 'gold',
              fontSize: '1.5rem',
              cursor: 'pointer',
              padding: '0 15px',
              display: 'flex',
              alignItems: 'center',
              fontSize: '36px'
            }}
            title="See previous day"
          >
            <i className="fa-solid fa-chevron-left"></i>
          </button>

          <div style={{
            width: '80%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            height: '100%',
            overflow: 'hidden',
            marginBottom: '20px'
          }}>
            {isLoadingGameOfDay ? (
              <div style={{ 
                color: 'gold', 
                textAlign: 'center', 
                padding: '20px',
                backgroundColor: '#222',
                borderRadius: '10px',
                width: '250px',
                height: '250px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <div>
                  <div style={{ fontSize: '24px', marginBottom: '10px', display: 'flex', justifyContent: 'center' }}>
                    <img 
                      src={chessslogo} 
                      alt="Chess Logo" 
                      style={{ width: '20px', height: 'auto' }} 
                    />
                  </div>
                  <p>Loading game...</p>
                  <style>
                    {`
                      @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                      }
                    `}
                  </style>
                </div>
              </div>
            ) : error ? (
              <div style={{ 
                color: 'red', 
                textAlign: 'center', 
                padding: '20px',
                backgroundColor: '#222',
                borderRadius: '10px',
                width: '250px',
                minHeight: '125px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <div>
                  <div style={{ fontSize: '24px', marginBottom: '10px' }}>
                    <i className="fa-solid fa-triangle-exclamation"></i>
                  </div>
                  <p>{error}</p>
                </div>
              </div>
            ) : loadedGameData.length > 0 && gameOfDay ? (
              <div key="game-of-day-container" style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <GameSummary
                  key={`game-of-day-${gameOfDay.id}`} 
                  gameData={gameOfDay}
                  boardWidth={250}
                  featured={true}
                  preventAutoFetch={true}
                  onClick={() => {
                    window.location.href = `/games/${gameOfDay.id}`;
                  }}
                />
              </div>
            ) : (
              <div style={{ 
                color: 'white', 
                textAlign: 'center', 
                padding: '20px',
                backgroundColor: '#222',
                borderRadius: '10px',
                width: '250px',
                minHeight: '125px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <div>
                  <div style={{ fontSize: '24px', marginBottom: '10px' }}>
                    <i className="fa-solid fa-chess-board"></i>
                  </div>
                  <p>No game found</p>
                </div>
              </div>
            )}

            {showPopup && (
              <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: 'rgba(255, 0, 0, 0.9)',
                color: 'white',
                padding: '15px 25px',
                borderRadius: '8px',
                fontWeight: 'bold',
                fontSize: '20px',
                zIndex: 100,
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)'
              }}>
                See you tomorrow :)
              </div>
            )}
          </div>

          <button
            onClick={nextGame} // This now goes to more RECENT days
            style={{
              background: 'transparent',
              border: 'none',
              color: 'gold',
              fontSize: '1.5rem',
              cursor: 'pointer',
              padding: '0 15px',
              display: 'flex',
              alignItems: 'center',
              fontSize: '36px'
            }}
            title="See more recent day"
          >
            <i className="fa-solid fa-chevron-right"></i>
          </button>
        </div>
      </div>
    );
  };

  // Function to handle follow notifications - creating or deleting them
  const handleFollowNotification = async (user, isFollowing) => {
    

    try {
      if (isFollowing) {
        // Add a new notification when following
        const docRef = await addDoc(collection(db, "notifications"), {
          type: "new_follower",
          followedBy: authenticatedUserHandle,
          followedTo: user,
          targetUser: user, // Add targetUser field for efficient querying
          status: "unread",
          timestamp: new Date()
        });
        
      } else {
        // Find and delete notification when unfollowing
        const notificationsQuery = query(
          collection(db, "notifications"),
          where("type", "==", "new_follower"),
          where("followedBy", "==", authenticatedUserHandle),
          where("followedTo", "==", user)
        );
        
        const notificationsSnapshot = await getDocs(notificationsQuery);
        
        if (!notificationsSnapshot.empty) {
          // Delete all matching notification documents (should typically be just one)
          const batch = writeBatch(db);
          
          notificationsSnapshot.forEach(doc => {
            batch.delete(doc.ref);
          });
          
          await batch.commit();
          
        } else {
          
        }
      }
    }
    catch (error) {
      // console.error(`Error ${isFollowing ? "creating" : "deleting"} follow notification:`, error);
    }
  }

  // Add function to follow a user
  const followUser = async (targetUserHandle) => {
    try {
      // Set loading state for this specific creator
      setFollowLoading(prev => ({...prev, [targetUserHandle]: true}));
      
      // Check if the user is authenticated
      if (!authenticatedUserHandle || !authenticatedUserId) {
        alert("You must be logged in to follow users");
        setFollowLoading(prev => ({...prev, [targetUserHandle]: false}));
        return false;
      }

      // Clean the handle by removing any @ symbol at the beginning
      const cleanedTargetHandle = targetUserHandle.replace(/^@/, '');

      // console.log("Follow attempt:", {
      //   currentUser: authenticatedUserHandle,
      //   targetUser: cleanedTargetHandle
      // });

      // Find the target user with a case-insensitive search
      // We'll create a compound query to check both the exact handle and a lowercase version
      const targetUserSnapshots = await Promise.all([
        // Try with the exact handle as provided
        getDocs(query(collection(db, "users"), where("handle", "==", cleanedTargetHandle))),
        
        // Try with lowercase (can match variations like "Wentan", "wentan", "WENTAN")
        getDocs(query(collection(db, "users"), where("handle", ">=", cleanedTargetHandle.toLowerCase()), 
                                              where("handle", "<=", cleanedTargetHandle.toLowerCase() + '\uf8ff')))
      ]);
      
      let targetUserDoc = null;
      let targetUserSnapshot = null;
      
      // Check the exact match query first
      if (!targetUserSnapshots[0].empty) {
        targetUserSnapshot = targetUserSnapshots[0];
        targetUserDoc = targetUserSnapshot.docs[0];
      } 
      // If no exact match, check the case-insensitive results
      else if (!targetUserSnapshots[1].empty) {
        // Filter the results to find a case-insensitive match
        const matchingDocs = targetUserSnapshots[1].docs.filter(doc => 
          doc.data().handle.toLowerCase() === cleanedTargetHandle.toLowerCase()
        );
        
        if (matchingDocs.length > 0) {
          targetUserDoc = matchingDocs[0];
        }
      }
      
      // If we still didn't find a match, return an error
      if (!targetUserDoc) {
        // console.error("Target user not found with handle:", cleanedTargetHandle);
        alert(`User "${cleanedTargetHandle}" not found in the database.`);
        setFollowLoading(prev => ({...prev, [targetUserHandle]: false}));
        return false;
      }
      
      const targetUserId = targetUserDoc.id;
      const actualTargetHandle = targetUserDoc.data().handle; // Use the actual case from the database
      
      // Start a batch write
      const batch = writeBatch(db);
      
      // Update current user's following list
      const currentUserRef = doc(db, "users", authenticatedUserHandle);
      const currentUserSnap = await getDoc(currentUserRef);
      
      if (!currentUserSnap.exists()) {
        // Try to find the user document by querying for the handle
        const currentUserQuery = query(
          collection(db, "users"),
          where("handle", "==", authenticatedUserHandle)
        );
        
        const currentUserSnapshot = await getDocs(currentUserQuery);
        
        if (currentUserSnapshot.empty) {
          // console.error("Current user not found");
          setFollowLoading(prev => ({...prev, [targetUserHandle]: false}));
          return false;
        }
        
        // Use the first matching document
        const currentUserDoc = currentUserSnapshot.docs[0];
        const currentUserData = currentUserDoc.data();
        
        // Create or update the following array
        const following = currentUserData.following || [];
        
        // Check if already following (case-insensitive)
        const normalizedTargetHandle = actualTargetHandle.toLowerCase();
        const alreadyFollowing = following.some(handle => 
          handle.toLowerCase() === normalizedTargetHandle
        );
        
        if (!alreadyFollowing) {
          // Store the handle with the correct case from the database
          following.push(actualTargetHandle);
          batch.update(doc(db, "users", currentUserDoc.id), { following });
        }
      } else {
        const currentUserData = currentUserSnap.data();
        
        // Create or update the following array
        const following = currentUserData.following || [];
        
        // Check if already following (case-insensitive)
        const normalizedTargetHandle = actualTargetHandle.toLowerCase();
        const alreadyFollowing = following.some(handle => 
          handle.toLowerCase() === normalizedTargetHandle
        );
        
        if (!alreadyFollowing) {
          // Store the handle with the correct case from the database
          following.push(actualTargetHandle);
          batch.update(currentUserRef, { following });
        }
      }
      
      // Update target user's followers list
      const targetUserData = targetUserDoc.data();
      
      // Create or update the followers array
      const followers = targetUserData.followers || [];
      
      // Check if already in followers (case-insensitive)
      const normalizedCurrentHandle = authenticatedUserHandle.toLowerCase();
      const alreadyInFollowers = followers.some(handle => 
        handle.toLowerCase() === normalizedCurrentHandle
      );
      
      if (!alreadyInFollowers) {
        followers.push(authenticatedUserHandle);
        batch.update(doc(db, "users", targetUserId), { followers });
      }
      
      // Commit the batch
      await batch.commit();
      
      // Create a follow notification
      await handleFollowNotification(actualTargetHandle, true);
      
      
      
      // Update the featured creators list to reflect the new follow status
      setFeaturedCreators(prevCreators => 
        prevCreators.map(creator => {
          const creatorUsername = creator.username.replace(/^@/, '');
          return creatorUsername.toLowerCase() === actualTargetHandle.toLowerCase() 
            ? {...creator, isFollowing: true} 
            : creator;
        })
      );
      
      setFollowLoading(prev => ({...prev, [targetUserHandle]: false}));
      return true;
    } catch (error) {
      // console.error("Error following user:", error);
      alert("Failed to follow user. Please try again.");
      setFollowLoading(prev => ({...prev, [targetUserHandle]: false}));
      return false;
    }
  };

  // Add function to check if current user is following a specific creator
  const checkIfFollowing = async (targetUserHandle) => {
    if (!authenticatedUserHandle || !targetUserHandle || targetUserHandle === authenticatedUserHandle) {
      return false;
    }

    try {
      // Clean the handle by removing any @ symbol at the beginning
      const cleanedTargetHandle = targetUserHandle.replace(/^@/, '');
      
      // Try to find the current user document
      const currentUserRef = doc(db, "users", authenticatedUserHandle);
      const currentUserSnap = await getDoc(currentUserRef);
      
      if (!currentUserSnap.exists()) {
        // As a fallback, try to find the user document by querying for the handle
        const currentUserQuery = query(
          collection(db, "users"),
          where("handle", "==", authenticatedUserHandle)
        );
        
        const currentUserSnapshot = await getDocs(currentUserQuery);
        
        if (currentUserSnapshot.empty) {
          // console.error("Could not find current user document");
          return false;
        }
        
        // Use the first matching document
        const userData = currentUserSnapshot.docs[0].data();
        const following = userData.following || [];
        
        // Use case-insensitive comparison
        const normalizedTargetHandle = cleanedTargetHandle.toLowerCase();
        return following.some(handle => handle.toLowerCase() === normalizedTargetHandle);
      }
      
      const userData = currentUserSnap.data();
      const following = userData.following || [];
      
      // Use case-insensitive comparison
      const normalizedTargetHandle = cleanedTargetHandle.toLowerCase();
      return following.some(handle => handle.toLowerCase() === normalizedTargetHandle);
    } catch (error) {
      // console.error("Error checking follow status:", error);
      return false;
    }
  };

  // Add function to check follow status of all featured creators
  const updateCreatorsFollowStatus = async (creators) => {
    if (!authenticatedUserHandle || creators.length === 0) {
      return creators;
    }
    
    try {
      
      
      const updatedCreators = await Promise.all(
        creators.map(async (creator) => {
          // Check if user is following this creator (clean the username to match database format)
          const isFollowing = await checkIfFollowing(creator.username);
          
          return { ...creator, isFollowing };
        })
      );
      
      return updatedCreators;
    } catch (error) {
      // console.error("Error checking creators follow status:", error);
      return creators;
    }
  };
  
  // Handle follow button click
  const handleFollowClick = async (creator) => {
    if (followLoading[creator.username]) return;
    
    if (creator.isFollowing) {
      // If already following, navigate to profile
      // Remove any @ from the username for the profile URL
      const cleanedUsername = creator.username.replace(/^@/, '');
      window.location.href = `/profile/${cleanedUsername}`;
    } else {
      // If not following, follow the user
      const success = await followUser(creator.username);
    }
  };

  // Update the renderFeaturedCreators function to include the new follow functionality
  const renderFeaturedCreators = () => {
    return (
      <div className="featured-creators" style={{
        backgroundColor: '#111',
        borderRadius: '10px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
      }}>
       
        
        {isLoadingCreators ? (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '20px'
          }}>
            <img 
              src={chessslogo} 
              alt="Chess Logo" 
              style={{ width: '30px', height: 'auto' }} 
            />
            <style>
              {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
            </style>
          </div>
        ) : (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '15px'
          }}>
            {featuredCreators.map((creator, index) => (
              <div key={`${creator.username}-${index}`} style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px',
                backgroundColor: '#1a1a1a',
                borderRadius: '8px',
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  paddingLeft: '10px'
                }}>
                  {/* <div style={{
                    width: '40px',
                    height: '40px',
                    backgroundImage: `url(${chessslogo})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                  }}></div> */}
                  <div>
                    <a 
                      href={creator.profileUrl || `/profile/${creator.username}`} 
                      style={{
                        textDecoration: 'none',
                        fontWeight: '',
                        fontSize: '20px',
                        color: 'gold'
                      }}
                    >
                      {creatorPremiumData[creator.username.replace(/^@/, '')] !== undefined 
                        ? renderUserWithBadge(creator.username, creatorPremiumData[creator.username.replace(/^@/, '')]) 
                        : renderUserWithBadge(creator.username)}
                    </a>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '5px', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                  
                  <button
                    onClick={() => handleFollowClick(creator)}
                    style={{
                      backgroundColor: creator.isFollowing ? 'gold' : 'transparent',
                      border: creator.isFollowing ? 'none' : '1px solid gold',
                      color: creator.isFollowing ? 'black' : 'gold',
                      padding: '5px 10px',
                      borderRadius: '5px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      minWidth: '80px',
                      opacity: followLoading[creator.username] ? 0.7 : 1
                    }}
                  >
                    {followLoading[creator.username] ? 
                      <i className="fa fa-spinner fa-spin"></i> : 
                      creator.isFollowing ? 'Profile' : 'Follow'}
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  // Add a style element for the YouTube iframe
  useEffect(() => {
    // Create a style element to target the YouTube iframe
    const styleEl = document.createElement('style');
    styleEl.textContent = `
      #youtube-player-container iframe {
        border-radius: 25px;
        max-width: 98% !important;
        max-height: 98% !important;
      }
    `;
    document.head.appendChild(styleEl);
    
    return () => {
      document.head.removeChild(styleEl);
    };
  }, []);

  return (
    <div className="app-container">
      {/* Include the font style definition */}
      <MansalvaFontStyle />
      
      <div className="explore-container" style={{
        display: 'grid',
        gridTemplateColumns: '1.1fr 1.1fr 1fr',
        gap: '20px',
        padding: '10px',
        maxWidth: '100%',
        margin: '0 auto',
        height: '98vh', // Slightly reduced height to prevent overflow
        maxHeight: '98vh', // Add max height constraint
        overflow: 'hidden' // Prevent container from expanding
      }}>
        {/* Left Column - Stacked Items */}
        <div className="left-column" style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          height: '100%',
          maxHeight: '98vh',
          overflow: 'hidden'
        }}>
          {/* Game Of The Day */}
          {renderGameOfDay()}

          {/* Rotating Content - Daily Tip, Quote, and Fact */}
          <div className="rotating-daily-content" style={{
            backgroundColor: '#111',
            borderRadius: '10px',
            padding: '10px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            display: 'flex',
            flexDirection: 'column',
            flex: '0 0 24%', // Fixed flex with 40% height
            overflow: 'hidden'
          }}>
            <h2 style={{
              color: 'white',
              margin: '5px 0 10px 0',
              textAlign: 'center',
              fontSize: '24px'
            }}>
              {contentType === 'tip' && 'Tip Of The Day'}
              {contentType === 'quote' && 'Quote Of The Day'}
              {contentType === 'fact' && 'Fact Of The Day'}
            </h2>

            <div style={{
              backgroundColor: '#222',
              borderRadius: '8px',
              padding: '15px',
              marginBottom: '10px',
              overflow: 'auto',
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {isLoadingDailyContent ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <img 
                    src={chessslogo} 
                    alt="Chess Logo" 
                    style={{ width: '30px', height: 'auto', animation: 'spin 2s linear infinite' }} 
                  />
                </div>
              ) : (
                <p 
                  style={{
                    color: 'white',
                    fontSize: '18px',
                    textAlign: 'center',
                    padding: '0px 10px',
                    fontStyle: contentType === 'quote' ? 'italic' : 'normal'
                  }}
                  dangerouslySetInnerHTML={{ 
                    __html: contentType === 'tip' 
                      ? dynamicTip 
                      : contentType === 'quote' 
                        ? dynamicQuote 
                        : dynamicFact
                  }}
                ></p>
              )}
            </div>
          </div>

         
        </div>

        {/* Middle Column - Featured Game (Video) */}
        <div className="" style={{
          backgroundColor: '#111',
          borderRadius: '10px',
          padding: '20px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-around',
          height: '100%',
          maxHeight: '92vh',
          overflow: 'hidden',
        }}>
          
          {/* Social Icons - Moved to top */}
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'gray',
            fontSize: '40px',
            width: '100%',
            gap: '15px'
          }}>
            <i className="fa-brands fa-youtube" style={{ cursor: 'pointer' }} onClick={() => window.open('https://www.youtube.com/@TheChessRepublicYT', '_blank')}></i>
            <i className="fa-brands fa-tiktok" style={{ cursor: 'pointer' }} onClick={() => window.open('https://www.tiktok.com/@thechessrepublic', '_blank')}></i>
            <i className="fa-brands fa-instagram" style={{ cursor: 'pointer' }} onClick={() => window.open('https://www.instagram.com/thechessrepublic/', '_blank')}></i>
            <i className="fa-brands fa-facebook" style={{ cursor: 'pointer' }}></i>
            <i className="fa-brands fa-x-twitter" style={{ cursor: 'pointer' }} onClick={() => window.open('https://x.com/ChessRepublicX', '_blank')}></i>
          </div>

          {/* Video Container with navigation */}
          <div style={{
            flex: '1', // Changed from fixed height to flex to maintain proportions
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '80%',
            position: 'relative'
          }}>
            <div 
              style={{
                width: '315px', // Width of iPhone frame
                height: '560px', // Height of iPhone frame
                position: 'relative',
                overflow: 'hidden'
              }}
            >
              {/* YouTube player container */}
              <div 
                id="youtube-player-container"
                style={{
                  width: '272px', // Slightly narrower to fit inside iPhone screen
                  height: '545px', // Slightly shorter to fit inside iPhone screen
                  position: 'absolute',
                  top: '10px', // Adjust to center in iPhone screen
                  left: '20px', // Adjust to center in iPhone screen
                  zIndex: 1, // Lower z-index to stay behind iPhone frame
                  border: 'none',
                  overflow: 'hidden',
                  borderRadius: '25px', // Match iPhone screen corner radius
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                {/* YouTube player will be inserted here by the API */}
              </div>
              
              {/* iPhone overlay */}
              <img 
                src={iPhone} 
                alt="iPhone frame" 
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '315px', // Match container width
                  height: '560px', // Match container height
                  zIndex: 2, // Higher z-index to overlay on top of video
                  pointerEvents: 'none' // Allow clicks to pass through to video
                }}
              />
            </div>
          </div>

          {/* Bottom Section - Premium button and navigation */}
          <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: ''
          }}>
            {/* Left/Right Video Navigation */}
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-around', alignItems: 'center', marginTop: '10px' }}>
              <div 
                style={{ 
                  color: '#ff0050', 
                  width: '40px', 
                  height: '40px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer',
                  borderRadius: '50%',
                  fontSize: '30px'
                }}
                onClick={prevVideo}
              >
                <i className="fa-solid fa-chevron-left"></i>
              </div>
              
              <button style={{ 
                backgroundColor: 'transparent', 
                border: '3px solid #ff0050', 
                color: '#ff0050', 
                padding: '15px 25px',
                display: 'flex',
                alignItems: 'center',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: 'bold'
              }}
              onClick={() => {
                // Check if user is premium and redirect accordingly
                if (isPremiumUser) {
                  window.location.href = '/premium-portal';
                } else {
                  window.location.href = '/premium';
                }
              }}>
                <i className="fa-solid fa-chess-queen" style={{ marginRight: '10px' }}></i>PREMIUM<i className="fa-solid fa-video" style={{ marginLeft: '10px' }}></i>
              </button>
              
              <div 
                style={{ 
                  color: '#ff0050', 
                  width: '40px', 
                  height: '40px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer',
                  borderRadius: '50%',
                  fontSize: '30px'
                }}
                onClick={nextVideo}
              >
                <i className="fa-solid fa-chevron-right"></i>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Stacked Items */}
        <div className="right-column" style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          height: '100%',
          maxHeight: '98vh',
          overflow: 'hidden'
        }}>

           {/* From The Community */}
           <div className="from-community" style={{
            backgroundColor: '#111',
            borderRadius: '10px',
            padding: '20px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            flex: '0 0 65%', // Take exactly 60% of the height
            overflow: 'hidden'
          }}>
            {/* Fixed header section */}
            <div style={{
              width: '100%',
              textAlign: 'center',
            }}>
              <h2 style={{
                color: 'white',
                margin: '0 0 10px 0',                
                textAlign: 'center',
                fontSize: '24px'
              }}>Featured Creators</h2>
            </div>

            {/* Scrollable content section */}
            <div style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              overflowY: 'auto',
              maxHeight: 'calc(100%)', // Subtract header height
              paddingRight: '5px', // Add some padding for the scrollbar
              scrollbarWidth: 'thin',
              scrollbarColor: '#ffd700 transparent'
            }}>
               {renderFeaturedCreators()}
            <div style={{
            }}>
              <blockquote className="twitter-tweet" data-theme="dark"><p lang="en" dir="ltr">When my chess app drops, cool things might happen.</p>&mdash; Christopher (@c4Polo) <a href="https://twitter.com/c4Polo/status/1894275736476803512?ref_src=twsrc%5Etfw">February 25, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
            </div>
             
            </div>
          </div>
          

          {/* Shop Chess */}
          <div className="shop-chess" style={{
            backgroundColor: '#111',
            borderRadius: '10px',
            padding: '20px 0px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: '0 21%', // Match Rotating Content height (25%)
            color: 'gold',
            position: 'relative',
            overflow: 'hidden',
            border: '1px solid rgba(255, 215, 0, 0.3)',
            cursor: 'pointer'
          }}
          // onClick={() => window.open('/shop', '_blank')}
          >
            <img src={Shop} style={{ width: '100%', height: 'auto', zIndex: 9999, rotate: '' }} />
            {/* Inner glow overlay */}
           
          </div>
        </div>
      </div>
    </div>
  );
};

Explore.propTypes = {
  getScreams: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user,
});

export default connect(mapStateToProps, { getScreams })(Explore);
